<template>
  <div id="burger" class="second-nav">
    <Slide
        :isOpen="menuOpen"
        width="415"
        right
        @openMenu="removeItemInFront"
        @closeMenu="addItemInFront"
        :class="{
        'slide-menu-open': menuOpen,
        'slide-menu-close': !menuOpen
      }"
    >
      <a id="menu-b" href="/">
        <img src="../../images/Logo hortense.svg" v-set-alt>
      </a>
      <div v-if="showDestinationSubmenu">
        <div class="back-button">
          <i class="fas fa-arrow-left w-100 h-100 d-flex align-items-center justify-content-center" @click.stop="clearSubmenu"></i>
        </div>
        <NavbarDestinationsPhone :destinations="destinations" />
      </div>
      <div v-else-if="showCollectionSubmenu">
        <div class="back-button">
          <i class="fas fa-arrow-left w-100 h-100 d-flex align-items-center justify-content-center" @click.stop="clearSubmenu"></i>
        </div>
        <NavbarCollectionsPhone :collections="collections" />
      </div>
      <div v-else-if="showSelectionSubmenu">
        <div class="back-button">
          <i class="fas fa-arrow-left w-100 h-100 d-flex align-items-center justify-content-center" @click.stop="clearSubmenu"></i>
        </div>
        <NavbarSelectionPhone />
      </div>
      <!-- <div v-else-if="showGiftBoxSubmenu">
        <div class="back-button">
          <i class="fas fa-arrow-left" @click.stop="clearSubmenu"></i>
        </div>
        <NavbarGiftBoxPhone />
      </div> -->
      <div v-else class="w-100 d-flex flex-column justify-content-center align-items-center">
        <ul class="nav-link" style="list-style: none; padding-left: 3rem;">
          <li class="item-nav raleway-reg-p16" @click.stop="showSelectionSubmenu = true">{{ $t("selection") }}</li>
          <li class="item-nav raleway-reg-p16" @click.stop="showCollectionSubmenu = true">{{ $t("collections") }}</li>
  <!--        <li class="item-nav raleway-reg-p16"><a :href="'/experiences-bien-etre'" class="no-deco">{{ $t("yogacation") }}</a></li>-->
  <!--        <li class="item-nav raleway-reg-p16"><a :href="'/offres-exclusives'" class="no-deco">{{ $t("exclusive") }}</a></li>-->
          <li class="item-nav raleway-reg-p16" @click.stop="showDestinationSubmenu = true">{{ $t("destinations") }}</li>
          <li class="item-nav raleway-reg-p16"> 
            <a href="/offres-exclusives-hortense" class="no-deco">
              Nos Offres Exclusives
            </a>
          </li>
          <li class="item-nav raleway-reg-p16"><a href="/seminaire-eco-responsable" class="no-deco" target="_blank">Hortense For Business</a></li>
          <!-- <li class="item-nav raleway-reg-p16" @click.stop="showGiftBoxSubmenu = true">Nos coffrets cadeaux</li> -->
          <!-- <li class="item-nav raleway-reg-p16"><a :href="'/inspirations-voyage-ecoresponsable'" class="no-deco">Inspirations</a></li> -->
          <!--        <li class="item-nav raleway-reg-p16"><a :href="'/experiences'" class="no-deco">{{ $t("experiences") }}</a></li>-->
          <!-- <li class="item-nav raleway-reg-p16"><a :href="'/galerie-hotel-ecoresponsable'" class="no-deco">Galerie</a></li> -->
          <li class="item-nav raleway-reg-p16"><a href="https://www.blog.hortense.green/" class="no-deco" target="_blank">{{ $t("newspaper") }}</a></li>
          <li class="item-nav raleway-reg-p16"><a href="/carte-cadeau" class="no-deco" target="_blank">Notre Carte Cadeau</a></li>
        </ul>
      
        <vue-tree-navigation :items="items" :defaultOpenLevel="0" />
        <div class="login-section raleway-bold-p" >
          <div v-if="this.user" class="d-flex">
            <a  :href="'/dashboard/' + this.user.slug" class="no-deco-profil">Mon profil | </a>
            <a href="/users/sign_out" data-method="delete" class="no-deco-profil">Déconnexion</a>
          </div>
          <div v-else class="d-flex raleway-bold-p12">
            <p class="no-deco-profil" @click="openModalSign">Créer un compte</p>
            <p class="px-4">|</p>
            <p class="no-deco-profil" @click="openModalLogin">Se connecter</p>

          </div>
        </div>
        <div @click="openWhatsApp" class="d-flex justify-content-center align-items-center w-100 pt-5" style="gap: 5px;">
          <i class="fa-brands fa-whatsapp" />
          <div class="raleway-reg-p15">Contactez-nous</div>
        </div>
      </div>
    </Slide>
  </div>
</template>

<script>
import { Slide } from 'vue-burger-menu';
import NavbarDestinationsPhone from '../shared/NavbarDestinationsPhone.vue';
import fetcher from 'packs/shared/api.js';
import NavbarCollectionsPhone from '../shared/NavbarCollectionsPhone.vue';
import NavbarSelectionPhone from '../shared/NavbarSelectionPhone.vue';
import NavbarGiftBoxPhone from '../shared/NavbarGiftBoxPhone.vue';
import { openWhatsAppWithPageLink } from '../../utils/whatsapp';

export default{
  name: 'BurgerTwo',
  props: ["user"],
  components: { Slide, NavbarDestinationsPhone, NavbarCollectionsPhone, NavbarSelectionPhone, NavbarGiftBoxPhone },
  data() {
    return {
      isActiveHortense: false,
      isActiveCurrencies: false,
      selectedCurrency: "FR/EUR",
      currencies: [{"currency": "FR/EUR", "lang": "fr"}, {"currency": "UK/GBP", "lang": "en"}, {'currency': "US/USD", "lang": "en"}],
      locale: 'fr',
      // origin: window.location.origin,

      items: [
        { name: 'Qui est hortense?', children: [
            { name: 'Qui est hortense?', path: '/qui-est-hortense/' },
            { name: 'La green note', path: '/la-green-note' },
            { name: 'Le programme evergreen', path: '/programme-evergreen' },
            { name: 'le Club Hortense', path: '/le-club-hortense/' },
            { name: 'LE PROGRAMME DE PARRAINAGE', path: '/sponsorships' },
          ]},
      ],

      itemsToggleDisplay: [],
      collections: [],
      destinations: [],
      showDestinationSubmenu: false,
      showCollectionSubmenu: false,
      showSelectionSubmenu: false,
      showGiftBoxSubmenu: false,
      menuOpen: false
    };
  },
  watch: {
    locale(val) {
      this._i18n.locale = val
    }
  },
  methods: {
    userInit(string){
      const names = string.split(','),
          initials = names[0].substring(0, 1).toUpperCase();
      if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1).toUpperCase();
      }
      return initials;
    },
    openModalSign(){
      this.$emit('showSignupModal');
      this.menuOpen = false;
    },
    openModalLogin() {
      this.$emit('showLoginModal');
      this.menuOpen = false;
    },
    showHortense() {
      this.isActiveHortense = !this.isActiveHortense;
    },
    showCurrencies(e) {
      const el = e.currentTarget.lastElementChild;
      el.style.transform = el.style.transform ? '' : 'rotateZ(180deg)';
      this.isActiveCurrencies = !this.isActiveCurrencies;
    },
    currenciesLeft() {
      return this.currencies.filter(x => {return x.currency !== this.selectedCurrency })
    },
    selectCurrency(e) {
      this._i18n.locale = e.currentTarget.value;
      this.selectedCurrency = e.currentTarget.innerText;
      this.isActiveCurrencies = false;
      const el = document.querySelector('.arrow');
      el.style.transform = el.style.transform ? '' : 'rotateZ(180deg)';
    },
    removeItemInFront() {
      this.menuOpen = true;
      this.$emit('menuOpened');
      this.itemsToggleDisplay.forEach(item => {
        if(item)
          item.classList.add('d-none')
      })
    },
    addItemInFront() {
      this.menuOpen = false;
      this.$emit('menuClosed');
      this.itemsToggleDisplay.forEach(item => {
        if(item)
          item.classList.remove('d-none')
      })
    },
    openWhatsApp() {
      openWhatsAppWithPageLink();
    },
    clearSubmenu() {
      this.showDestinationSubmenu = false;
      this.showCollectionSubmenu = false;
      this.showSelectionSubmenu = false;
      this.showGiftBoxSubmenu = false;
    },
    fetchDestinations() {
      const response = fetcher.get('/destination', {
        params: { countries: ['FRANCE', 'OCÉAN INDIEN', 'CARAÏBES', 'AFRIQUE'] }
      }).then(response => {
        this.destinations = response.data;
      }).catch(error => {
        console.error('Error fetching destinations:', error);
      });
    },
    async fetchCollections() {
      try {
        const response = await fetch('/collections.json');
        if (response.ok) {
          this.collections = await response.json();
        }
      } catch (error) {
        console.error('Error fetching collections:', error);
      }
    },
  },
  mounted() {
    this.fetchDestinations();
    this.fetchCollections();
    this.itemsToggleDisplay = [
      document.querySelector('.phone-btn'),
      document.querySelector('.select-list')
    ]
  }
}
</script>

<style lang="scss" scope='app/assets/stylesheets/components/burger' scoped>
.second-nav .bm-burger-button {
  width: 36px;
  height: 35px;
  left: 36px;
  top: 20% !important;
  cursor: pointer;
}
.back-button {
  width: 33px;
  height: 33px;
  padding: 5px 10px;
  border-radius: 8.25px;
  background-color: #BFBFBF;
}
</style>
